import React, { useEffect, useState } from "react";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import { Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

// ตัวเลือกธีม — บันทึกลง localStorage และปรับ attribute บน <html> เช่นเดียวกับเมนูตั้งค่าใน Header
const SIDEBAR_SKINS = [
  { key: "default", label: "ค่าเริ่มต้น" },
  { key: "prime", label: "Prime" },
  { key: "dark", label: "Dark" },
  { key: "green", label: "Green" },
  { key: "purple", label: "Purple" },
  { key: "orange", label: "Orange" },
  { key: "red", label: "Red" },
  { key: "teal", label: "Teal" },
];

export default function AccountSettings() {
  const [skin, setSkin] = useState(localStorage.getItem("skin-mode") ? "dark" : "");
  const [sidebarSkin, setSidebarSkin] = useState(localStorage.getItem("sidebar-skin") || "default");

  // sync skin state to the Header (re-applies table/btn styles via onSkin)
  useEffect(() => {}, [skin]);

  const applySkinMode = (mode) => {
    const html = document.querySelector("html");
    if (mode === "dark") {
      html.setAttribute("data-skin", "dark");
      localStorage.setItem("skin-mode", "dark");
      setSkin("dark");
    } else {
      html.removeAttribute("data-skin");
      localStorage.removeItem("skin-mode");
      setSkin("");
    }
  };

  const applySidebarSkin = (key) => {
    const html = document.querySelector("html");
    html.removeAttribute("data-sidebar");
    if (key !== "default") {
      html.setAttribute("data-sidebar", key);
      localStorage.setItem("sidebar-skin", key);
    } else {
      localStorage.removeItem("sidebar-skin");
    }
    setSidebarSkin(key);
  };

  return (
    <React.Fragment>
      <Header onSkin={setSkin} />
      <div className="main main-app p-3 p-lg-4">
        <div className="d-sm-flex align-items-center justify-content-between mb-4">
          <div>
            <ol className="breadcrumb fs-sm mb-1">
              <li className="breadcrumb-item"><Link to="#">บัญชีผู้ใช้</Link></li>
              <li className="breadcrumb-item active" aria-current="page">ตั้งค่าบัญชีผู้ใช้</li>
            </ol>
            <h4 className="main-title mb-0">ตั้งค่าบัญชีผู้ใช้</h4>
          </div>
        </div>

        <Row className="g-3">
          <Col xl="8">
            {/* ───── ธีมหน้าจอ ───── */}
            <Card className="card-one mb-3">
              <Card.Header><Card.Title as="h6">ธีมหน้าจอ (Skin Mode)</Card.Title></Card.Header>
              <Card.Body>
                <p className="fs-sm text-secondary">เลือกโหมดสว่างหรือมืดตามความถนัดในการใช้งาน</p>
                <div className="d-flex gap-3">
                  {[
                    { key: "", label: "สว่าง (Light)", icon: "ri-sun-line" },
                    { key: "dark", label: "มืด (Dark)", icon: "ri-moon-line" },
                  ].map((opt) => {
                    const active = (skin || "") === opt.key;
                    return (
                      <button
                        key={opt.key || "light"}
                        type="button"
                        onClick={() => applySkinMode(opt.key)}
                        className={`btn ${active ? "btn-primary" : "btn-outline-secondary"} d-flex align-items-center gap-2`}
                        style={{ minWidth: 160, justifyContent: "center" }}
                      >
                        <i className={opt.icon}></i> {opt.label}
                        {active && <i className="ri-check-line ms-1"></i>}
                      </button>
                    );
                  })}
                </div>
              </Card.Body>
            </Card>

            {/* ───── ธีมแถบเมนู ───── */}
            <Card className="card-one mb-3">
              <Card.Header><Card.Title as="h6">ธีมแถบเมนูด้านข้าง (Sidebar)</Card.Title></Card.Header>
              <Card.Body>
                <div className="d-flex gap-3 flex-wrap">
                  {SIDEBAR_SKINS.map((opt) => {
                    const active = sidebarSkin === opt.key;
                    return (
                      <button
                        key={opt.key}
                        type="button"
                        onClick={() => applySidebarSkin(opt.key)}
                        className={`btn ${active ? "btn-primary" : "btn-outline-secondary"}`}
                        style={{ minWidth: 130 }}
                      >
                        {opt.label}
                        {active && <i className="ri-check-line ms-1"></i>}
                      </button>
                    );
                  })}
                </div>
              </Card.Body>
            </Card>
          </Col>

          {/* ───── ความปลอดภัย / ลัด ───── */}
          <Col xl="4">
            <Card className="card-one">
              <Card.Header><Card.Title as="h6">บัญชีและความปลอดภัย</Card.Title></Card.Header>
              <Card.Body>
                <div className="list-group list-group-flush">
                  <Link to="/account/profile" className="list-group-item list-group-item-action d-flex align-items-center gap-2 px-0">
                    <i className="ri-profile-line fs-18 text-primary"></i>
                    <span>ดูโปรไฟล์ของฉัน</span>
                    <i className="ri-arrow-right-s-line ms-auto text-secondary"></i>
                  </Link>
                  <Link to="/account/profile/edit" className="list-group-item list-group-item-action d-flex align-items-center gap-2 px-0">
                    <i className="ri-edit-2-line fs-18 text-primary"></i>
                    <span>แก้ไขโปรไฟล์</span>
                    <i className="ri-arrow-right-s-line ms-auto text-secondary"></i>
                  </Link>
                  <Link to="/pages/change-password" className="list-group-item list-group-item-action d-flex align-items-center gap-2 px-0">
                    <i className="ri-lock-line fs-18 text-primary"></i>
                    <span>เปลี่ยนรหัสผ่าน</span>
                    <i className="ri-arrow-right-s-line ms-auto text-secondary"></i>
                  </Link>
                </div>
                <p className="fs-xs text-secondary mt-3 mb-0">
                  การตั้งค่าธีมจะถูกบันทึกไว้ในเบราว์เซอร์ของเครื่องนี้
                </p>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Footer />
      </div>
    </React.Fragment>
  );
}
